import React from 'react';
import {
  CircularProgressContainer,
  CircularProgressSVG,
  CircularProgressBackground,
  CircularProgressForeground,
  ProgressText
} from './CircularProgress.styles';

export interface CircularProgressProps {
  value: number;
  maxValue: number;
  size?: number;
  strokeWidth?: number;
  primaryColor?: string;
  secondaryColor?: string;
  fontSize?: number;
  label?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  value,
  maxValue,
  size = 150,
  strokeWidth = 12,
  primaryColor = '#4361ee',
  secondaryColor = '#e6e6e6',
  fontSize = 32,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progressPercentage = Math.min(Math.max(value / maxValue, 0), 1);
  const dashOffset = circumference * (1 - progressPercentage);

  return (
    <div>
      <CircularProgressContainer size={size}>
        <CircularProgressSVG width={size} height={size}>
          <CircularProgressBackground
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            color={secondaryColor}
          />
          <CircularProgressForeground
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            color={primaryColor}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
          />
        </CircularProgressSVG>
        <ProgressText fontSize={fontSize}>
          {value}/{maxValue}
        </ProgressText>
      </CircularProgressContainer>
    </div>
  );
};

export default CircularProgress;
